<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="changePassword">
      <v-row class="pa-6 ma-0">
        <v-col cols="12" sm="12" md="4" lg="4">
          <span class="label">Senha atual<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              color="normalred"
              dense
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass ? 'text' : 'password'"
              outlined
              v-model="password"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              @click:append="showPass = !showPass"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="4" lg="4">
          <span class="label">Nova senha<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              color="normalred"
              dense
              :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPass ? 'text' : 'password'"
              outlined
              v-model="newPassword"
              :rules="[(v) => !!v || 'Campo obrigatório']"
              @click:append="showNewPass = !showNewPass"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="4" lg="4">
          <span class="label">Confirma sua nova senha<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              color="normalred"
              dense
              :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConfirm ? 'text' : 'password'"
              outlined
              :rules="[(v) => v == newPassword || 'Senhas não batem']"
              v-model="confirmPassword"
              @click:append="showConfirm = !showConfirm"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";

export default {
  name: "ChangePassword",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    showPass: false,
    password: "",
    newPassword: "",
    showNewPass: false,
    confirmPassword: "",
    showConfirm: false,
    loading: true,
    currentUser: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: "",
      latitude: null,
      longitude: null,
    },
    apiService: new ApiService(),
    user: {},
    dialog: false,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    isEditing: false,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    },
    estados: [
      "AC",
      "AL",
      "AM",
      "AP",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RO",
      "RS",
      "RR",
      "SC",
      "SE",
      "SP",
      "TO",
    ],
  }),
  async created() {
    await this.updateUser();
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    async updateUser() {
      this.loading = true;
      let user = JSON.parse(localStorage.getItem("user"));
      let url;
      switch (user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }

      this.Id = user.id;
      await this.apiService.get(`${url}?id=${this.Id}`).then((response) => {
        this.currentUser = response;
        localStorage.setItem("user", JSON.stringify(this.currentUser));
        this.loading = false;
      });
    },
    validate() {
      if (this.$refs.changePassword.validate()) {
        this.dialog = true;
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
      }
    },
    async submit() {
      try {
        const model = {
          id: this.currentUser.id,
          currentPassword: this.password,
          newPassword: this.newPassword,
        };
        this.apiService.post("user/password/update", model)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "Senha alterada com sucesso",
                message: "Senha alterada com sucesso",
                trace: null,
              });

              this.$refs.changePassword.reset();
              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro",
                message: err.body.message,
                trace: null,
              });
              this.$refs.changePassword.reset();
              this.dialog = false;
              this.loading = false;
            });
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
